import { Link } from "react-router-dom";
import { Crown, Sparkles, Zap, ArrowLeft, Film } from "lucide-react";
import { useT } from "@/i18n";

/**
 * Full-page upgrade gate shown to Free users when they hit the AI Video
 * Producer route. Mirrors the Interview upgrade gate for brand consistency.
 */
export default function VideoUpgradeGate() {
  const { t } = useT();
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8" data-testid="video-upgrade-gate">
      <div className="max-w-lg w-full bg-white border-2 border-zinc-900 rounded-2xl overflow-hidden shadow-xl">
        <div className="bg-gradient-to-br from-blue-600 to-purple-600 text-white px-8 py-8 text-center">
          <div className="inline-flex w-16 h-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
            <Film className="w-9 h-9" />
          </div>
          <h1 className="mt-4 text-3xl font-black tracking-tight">{t("vd_gate_title") || "AI Video Producer is locked"}</h1>
          <p className="mt-2 text-base text-white/95">{t("vd_gate_sub") || "Real AI videos with Sora 2 — Creator & Pro plans only."}</p>
        </div>

        <div className="px-8 py-6">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-3">
            {t("vd_gate_what_you_get") || "What you unlock"}
          </div>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" /> {t("vd_gate_b1") || "Real cinematic AI video clips (Sora 2)"}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" /> {t("vd_gate_b2") || "Multi-scene videos with AI narration in 9 languages"}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" /> {t("vd_gate_b3") || "1280×720 MP4 download — no watermark"}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" /> {t("vd_gate_b4") || "Up to 15 videos/month on Creator, 50 on Pro"}</li>
          </ul>

          <Link
            to="/app/billing"
            className="mt-6 inline-flex w-full items-center justify-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white font-bold py-3.5 rounded-md"
            data-testid="vd-gate-cta"
          >
            <Crown className="w-4 h-4" /> <Zap className="w-4 h-4" /> {t("vd_gate_cta") || "Upgrade to unlock"}
          </Link>
          <Link
            to="/app"
            className="mt-3 inline-flex w-full items-center justify-center gap-1 text-sm text-zinc-500 hover:text-zinc-900 py-2"
            data-testid="vd-gate-back"
          >
            <ArrowLeft className="w-4 h-4" /> {t("vd_gate_back") || "Back to Dashboard"}
          </Link>
        </div>
      </div>
    </div>
  );
}
